import { render, staticRenderFns } from "./ChallangeForm.vue?vue&type=template&id=9592f5f8&"
import script from "./ChallangeForm.vue?vue&type=script&lang=js&"
export * from "./ChallangeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports